import React, { useContext } from "react";
import AttachmentsCard from "../../../../../../../../../../components/Attachment/AttachmentsCard";
import { OrderContext } from "../../pages/Preview";
import OrderBasicInfoCard from "../OrderPreview/OrderBasicInfoCard";
import OrderItemsCard from "../OrderPreview/OrderItemsCard/OrderItemsCard";
import OrderShipsCard from "../OrderPreview/OrderShips/OrderShipsCard";

const OrderPreviewTab = () => {
	const { order, fetchOrderShips, fetchOrder } = useContext(OrderContext);

	const handleUpdate = async () => {
		const promises = [fetchOrder(), fetchOrderShips && fetchOrderShips()];
		await Promise.all(promises);
	};

	return (
		<div className="col px-0">
			<OrderShipsCard handleUpdate={handleUpdate} />
			<OrderBasicInfoCard />
			{order?.items?.length > 0 && <OrderItemsCard />}
			{order?.file_attachments?.length > 0 && <AttachmentsCard attachments={order.file_attachments} />}
		</div>
	);
};

export default OrderPreviewTab;
